export const InitialValue = Object.freeze({
    IdCotizacion: 0,
    Cliente: {
        Nombre: "",
        EMail: ""
    }
})